// src/components/DataTable.js
import React, { useState, useEffect } from 'react';
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  TextField,
  Typography,
  Container,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Stack,
} from '@mui/material';
import {
  getCompanySuppliersAction,
  getInvoicesPaginatedAction,
} from './Action';
import moment from 'moment';
import {
  SupplierModuleTypeEnum,
} from '../../utils/settings';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useDispatch } from 'react-redux';
import TableSkeletonLoader from '../Components/TabelSkelotonLoader';

export default function InvoicesList() {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [startEndDate, setStartEndDate] = useState({
    startDate: moment(moment().subtract(30, 'days')).format('YYYY-MM-DD'),
    endDate: moment().format('YYYY-MM-DD'),
  });
  const [companiesList, setCompaniesList] = useState([]);
  const [company, setCompany] = useState({});

  const [invoicesList, setInvoicesList] = useState();
  const [isLoading, setIsLoading] = useState(false);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(event.target.value);
    setPage(0);
  };
  const getCompany = async () => {
    const { data, error, message } = await getCompanySuppliersAction(
      SupplierModuleTypeEnum.dp_history_enabled,
    );

    if (!error) {
      let list = [];
      data.map((industry) => {
        industry.suppliers_list.map((supplier) => {
          list.push({
            id: supplier.id,
            name: supplier.name,
          });
        });
      });

      setCompaniesList(list);
    } else {
      //Throw error
    }
  };

  useEffect(() => {
    getCompany();
  }, []);

  const getInvoices = async () => {
    setIsLoading(true);
    const params = new URLSearchParams();
    params.append('f', 'id$gte$0');
    params.append('o', 'id$desc');
    params.append('page', page + 1);
    params.append('page_size', rowsPerPage);

    if (startEndDate.startDate || startEndDate.endDate) {
      params.append(
        'f',
        `date_of_invoice$gte$${moment(startEndDate.startDate)
          .subtract(1, 'days')
          .format('YYYY-MM-DD')}`,
      );
      params.append(
        'f',
        `date_of_invoice$lte$${moment(startEndDate.endDate)
          .add(2, 'days')
          .format('YYYY-MM-DD')}`,
      );
    }
    if (Object.keys(company).length > 0) {
      params.append('f', `buy_or_sell_to$eq$${company.id}`);
    }

    const { data, error, message } = await getInvoicesPaginatedAction(params);
    setIsLoading(false);
    if (!error) {
      setInvoicesList(data);
    } else {
      return toast.error(message);
    }
  };

  useEffect(() => {
    if (startEndDate.startDate && startEndDate.endDate) getInvoices();
  }, [page, rowsPerPage, startEndDate, company]);

  return (
    <>
      <Container
        maxWidth='true'
        sx={{
          pl: '2rem',
          pt: '2rem',
          height: window.innerHeight,
          overflowY: 'auto',
          backgroundColor: '#f5f5f5',
        }}
      >
        {' '}
        <Typography
          variant='h5'
          style={{ marginBottom: '2rem', fontWeight: 'bold' }}
        >
          Completed Invoices
        </Typography>
        <Stack
          direction={'row'}
          spacing={2}
          marginBottom={4}
        >
          <FormControl sx={{ marginLeft: '2rem', width: '20%' }}>
            <InputLabel>Select Company</InputLabel>
            <Select
              value={company?.id}
              label='Select Company'
              onChange={(e) => {
                setCompany({
                  id: e.target.value,
                  name: e.target.name,
                });
              }}
            >
              {companiesList &&
                companiesList.length > 0 &&
                companiesList.map((company) => (
                  <MenuItem
                    value={company.id}
                    key={company.id}
                  >
                    {company.name}
                  </MenuItem>
                ))}
            </Select>
          </FormControl>
          <TextField
            label='Start Date'
            type='date'
            InputLabelProps={{ shrink: true }}
            value={startEndDate.startDate}
            sx={{ mr: 2 }}
            onChange={(e) => {
              setStartEndDate({
                ...startEndDate,
                startDate: e.target.value,
              });
            }}
          />
          <TextField
            label='End Date'
            type='date'
            value={startEndDate.endDate}
            InputLabelProps={{ shrink: true }}
            onChange={(e) => {
              setStartEndDate({
                ...startEndDate,
                endDate: e.target.value,
              });
            }}
          />
        </Stack>
        {isLoading ? (
          <TableSkeletonLoader
            rowCount={11}
            columnCount={6}
          />
        ) : (
          <Paper sx={{ width: '100%', mb: 2 }}>
            <TableContainer>
              <Table aria-label='simple table'>
                <TableHead>
                  <TableRow>
                    <TableCell align='center'>Company Name</TableCell>
                    <TableCell align='center'>Invoiced Date</TableCell>
                    <TableCell align='center'>Invoiced Number</TableCell>
                    <TableCell align='center'>Ship to Party</TableCell>
                    <TableCell align='center'>Invoiced Qty</TableCell>
                    <TableCell align='center'>Invoiced Amount</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {invoicesList?.map((row, index) => (
                    <TableRow
                      key={index}
                      sx={{
                        cursor: 'pointer',
                      }}
                      onClick={() => {
                        navigate(
                          `/order-booking/invoice-details/${row.invoice_id}`,
                        );
                      }}
                    >
                      <TableCell align='center'>
                        {row.buy_or_sell_to_company_name
                          ? row.buy_or_sell_to_company_name
                          : '-'}
                      </TableCell>
                      <TableCell align='center'>
                        {row.date_of_invoice ? row.date_of_invoice : '-'}
                      </TableCell>
                      <TableCell align='center'>
                        {row.invoice_no ? row.invoice_no : '-'}
                      </TableCell>
                      <TableCell align='center'>
                        {row.company_name ? row.company_name : '-'}
                      </TableCell>
                      <TableCell align='center'>
                        {row.quantity ? row.quantity : '-'}
                      </TableCell>
                      <TableCell align='center'>
                        {row.invoiced_amount ? row.invoiced_amount : '-'}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
            <TablePagination
              rowsPerPageOptions={[10, 25, 50]}
              component='div'
              count={100}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              labelDisplayedRows={({ from, to, count, page }) =>
                `${from}-${to} of ${count !== -1 ? count : `more than ${to}`}`
              }
            />
          </Paper>
        )}
      </Container>
    </>
  );
}
